import React from "react";
import { App } from "@capacitor/app";
import { Button } from "@/components/ui/button";
import { ForceUpgradeResult } from "@/lib/versionCheck";

interface ForceUpgradeScreenProps {
  result: ForceUpgradeResult;
}

export function ForceUpgradeScreen({ result }: ForceUpgradeScreenProps) {
  const openStore = async () => {
    try {
      await App.openUrl({ url: result.storeUrl });
    } catch {
      window.open(result.storeUrl, "_blank");
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6 bg-background"
      style={{ paddingTop: "var(--safe-area-inset-top, 0)", paddingBottom: "var(--safe-area-inset-bottom, 0)" }}
    >
      <div className="max-w-sm w-full text-center space-y-6">
        <h1 className="text-xl font-semibold text-foreground">
          Update required
        </h1>
        <p className="text-muted-foreground text-sm">
          A new version of the app is required to continue. Please update from the Play Store.
        </p>
        <p className="text-muted-foreground text-xs">
          Your version: {result.currentVersion} → Required: {result.minVersion}
        </p>
        <Button className="w-full" size="lg" onClick={openStore}>
          Open Play Store
        </Button>
      </div>
    </div>
  );
}
